import React from 'react';

function FileIcon() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
      <path fill="#9D9D9C" d="M36,36H4V4h20v12h12V36z M29.8,2.1C28.7,1,26.4,0,24.7,0H3C1.3,0,0,1.3,0,3 v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V15.4c0-1.7-0.9-4-2.1-5.1L29.8,2.1z" />
    </svg>
  );
}

export default FileIcon;



// WEBPACK FOOTER //
// ./src/components/icons/FileIcon.js